import React, { useEffect, useState, useContext, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import FormSection from 'components/sales/formSection/formSectionNew';
import TableSection from 'components/sales/tableSection/tableSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import CardSection from 'components/sales/cardSection/cardSection';
import './rmLog.css';

const RmLog = ({
  match,
  getRMTicketLog,
  rmTicketLog
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const Headers = ['Created By', 'Action', 'Remark','Created At'];
  const [isLoading, setIsLoading] = useState(false);
  

  useEffect(() => {
    if (getRMTicketLog !== null && match.params.id)
      (async () => {
        setIsLoading(true);
        await getRMTicketLog(match.params.id);
        setIsLoading(false);
      })();
  }, [getRMTicketLog, match.params.id]);

 

  return (
    <Layout
      title={'RM Ticket Log'}
      isGoback
      linkFlag={true}
      linkUrl={
        `${baseUrl}/rm-tickets`
      }
      isLoading={isLoading}
    >
      <div>
      { rmTicketLog && rmTicketLog.details && 
      <CardSection title={'Details'}>
        <div className="details-listing">
          <DivLayout
            heading={'Complaint Id'}
            data={rmTicketLog.details && rmTicketLog.details.complaint_id}
          />
          
          
          <DivLayout
            heading={localization.siteNumber}
            data={rmTicketLog.details && rmTicketLog.details.site_no}
          />
          <DivLayout
            heading={localization.siteName}
            data={
              rmTicketLog.details && rmTicketLog.details.client_name
            }
          />
         
         
        </div>
      </CardSection>
      }
        <FormSection title={'RM Ticket Log'}>
          <div className="details-listing">
            { rmTicketLog && rmTicketLog.data && 
            
            <TableSection
              data={rmTicketLog.data}
              headers={Headers}
            ></TableSection> 
            }
          </div>
        </FormSection>

        
      </div>
      
    </Layout>
  );
};

export default RmLog;
